<template>
  <div class="ticket">
    <div class="container">
      <div class="titleNav">
        <a href="">我要下单</a> /
        <router-link to="/ticket">票务服务</router-link>
      </div>
      <div class="content">
        <div class="left">
          <trip @way="way" />
        </div>
        <div class="right">
          <div class="depart">
            <label for="">
              <span>选择出发日期:</span>
              <!--<date-time @time="times" :type="type"></date-time>-->
              <!-- <el-date-picker
                      v-model="value1"
                      @change="changeTime"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
              </el-date-picker> -->
                 <el-date-picker
                type="dates"
                 @change="changeTime"
                v-model="value1"
                placeholder="选择一个或多个日期">
              </el-date-picker>
            </label>
            <label for="">
              <span>出发地:</span>
              <input type="text" placeholder="请输入出发地" v-model="info.departurePlace">
            </label>
            <label for="">
              <span>目的地:</span>
              <input type="text" placeholder="请输入目的地" v-model="info.destinationPlace">
            </label>
            <label for="">
              <span>车次:</span>
              <input type="text" placeholder="请输入车次" v-model="info.trainNumber">
            </label>
            <p class="notice">注：不输入表示无要求</p>
          </div>
          <button class="next" @click="next">下一步</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Trip from '../../../components/Courier/Trip'
import {formatDate} from '../../../utils/date'
// import DateTime from '../../../components/Time'
export default {
  data () {
    return {
      info: {
        travelMode: '',
        seatType: [],
        departureDate: '',
        departurePlace: '',
        destinationPlace: '',
        trainNumber: ''
      },
      value1: ''
      // type: 'datetime' // 时间类型
    }
  },
  methods: {
    // 获取出行方式
    way(refereeArr, trip) {
      this.info.travelMode = trip
      this.info.seatType = refereeArr
    },
    // 获取时间
    changeTime(val) {
       let arrDate=[]
        val.forEach(item=>{
          arrDate.push(formatDate(new Date(item), 'yyyy-MM-dd ')+'00:00:00')
        })
      this.info.departureDate = arrDate.join(',')
      return
      let date1 = new Date(val[0])
      let time1 = formatDate(date1, 'yyyy-MM-dd ')
      let date2 = new Date(val[1])
      let time2 = formatDate(date2, 'yyyy-MM-dd ')
     
      console.log("2",time1, time2)
      this.getDayAll(time1, time2)
    },
    // 按填查询
    getDayAll(begin, end) {
      Date.prototype.format = function () {
        var s = '';
        s += this.getFullYear() + '-';          // 获取年份。
        s += (this.getMonth() + 1) + "-";         // 获取月份。
        s += this.getDate();                 // 获取日。
        return (s + ' 00:00:00');                          // 返回日期。
      };
      var dateAllArr = new Array();
      var ab = begin.split("-");
      var ae = end.split("-");
      var db = new Date();
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
      var de = new Date();
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
      var unixDb = db.getTime();
      var unixDe = de.getTime();
      for (var k = unixDb; k <= unixDe;) {
        dateAllArr.push((new Date(parseInt(k))).format().toString());
        k = k + 24 * 60 * 60 * 1000;
      }
      // console.log(this.orgOptions.xAxis.data);
      this.info.departureDate = dateAllArr.join(',')
        console.log("3",dateAllArr,this.info.departureDate );
      // this.orgOptions.xAxis.data = dateAllArr
    },
    // times (time) {
    //   this.info.departureDate = time
    // },
    next () {
      const {travelMode, seatType, departureDate, departurePlace, destinationPlace} = this.info
      if(JSON.stringify(seatType) === '[]'){
        this.$message({
          message: '请选择出行方式',
          type: 'error'
        })
      } else if(!departureDate){
        this.$message({
          message: '请选择出发日期',
          type: 'error'
        })
      } else if(!departurePlace){
        this.$message({
          message: '请填入出发地',
          type: 'error'
        })
      } else if(!destinationPlace){
        this.$message({
          message: '请填入目的地',
          type: 'error'
        })
      } else {
        this.$store.dispatch('getTicketInfo', this.info).then(() => {
          this.$router.push({name: 'TicketOrder'})
        })


      }
    }
  },
  components: {
    Trip,
    // DateTime
  }
}
</script>

<style scoped lang="less" type="text/less">
.ticket{
  margin-bottom: 127px;
  .titleNav{
    margin:30px 0 41px;
  }
  .content{
    display: flex;
    .left{
      width: 600px;

    }
    .right{
      width: 500px;
      .depart{
        label{
          display: flex;
          margin-bottom: 20px;
          &:last-of-type{
            margin-bottom: 11px;
          }
          span{
            display: block;
            width: 90px;
            text-align: right;
            line-height: 40px;
            margin-right: 12px;
          }
          input{
            width: 340px;
            height: 40px;
            text-indent: 13px;
            box-sizing: border-box;
            border:1px solid #e1e1e1;
            border-radius: 4px;
            &::-webkit-input-placeholder{
              color:#c0c4cc;
            }
          }
        }
        .notice{
          color:#999;
          text-indent: 102px;
        }

      }
      .next{
        display: block;
        width: 332px;
        height: 48px;
        border:none;
        margin:48px auto 0;
        background: #61aee6;
        color: #fff;
        border-radius: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Courier/Ticket/Ticket.vue